import React, { useCallback, useState, useContext, useEffect } from "react";
import styled from "styled-components";
import TextField from "../Common/TextField";
import womanDoctor from "../../SVGs/womanDoctor.svg";
import CustomButton from "../Common/CustomButton";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../Context/user_context";
import RequireLogout from "../../permissions.js/RequireLogout";
import Cookies from "js-cookie";
import { toast } from "react-hot-toast";
import { useLocation } from "react-router-dom";
import PageLoader from "../Common/PageLoader";

import {
  getApiClient,
  makeStandardApiErrorHandler,
} from "../../server/get_api_client";
import Nav from "../Common/Nav";
import Footer from "../Common/Footer";

function Login() {
  const [Username, setUsername] = useState("");
  const [Password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigation = useNavigate();
  const location = useLocation();

  const { setUser } = useContext(UserContext);



  const Submit = useCallback(() => {
    setIsLoading(true);

    getApiClient()
      .Login(Username, Password)
      .then((res) => {
        if (res.data.existingCust) {
          navigation("/Otp", {
            state: {
              username: Username,
              passowrd: Password,
              email: res.data.email,
              forgetPassword: false, 
            },
          });
        }
        else if (res.data) {
          Cookies.set("hippocratic_portal_token", res.data.token, {
            expires: 1 / 24,
            secure: true,
            sameSite: "Strict",
          });
          Cookies.set("hippocratic_portal_contactid", res.data.contactid, {
            expires: 1 / 24,
            secure: true,
            sameSite: "Strict",
          });

          if (res.data.initialUpdate) {
            navigation("/Overview");
          } else {
            navigation("/MyInformation");
          }
          window.location.reload();
        } else {
          setError("Wrong username or password");
          setIsLoading(false);
        }
      })
      .catch(
        makeStandardApiErrorHandler((error) => {
          setError("Wrong username or password");
          setIsLoading(false);
        })
      );
  }, [Username, Password, isLoading, setUser]);

  useEffect(() => {
    setError("");
  }, [Username, Password]);

  const handleKeyDown = useCallback((event) => {
    if (event.key === 'Enter' && !isLoading) {
      Submit();
    }
  }, [Submit, isLoading]);
  
  useEffect(() => {
    if (location.state?.message) {
      toast.success(location.state.message);
    }
  }, []);

  return (
    <>
      <PageLoader isLoading={isLoading} />
      <Nav />
      <Container>
        <InnerContainer>
          <LeftContaienr onKeyDown={handleKeyDown} tabIndex="0">
            <LeftContaienrBanner>          <Title>SIGN IN</Title></LeftContaienrBanner>
            <LeftContaienrContent>
            <Text>
              Sign in with your Hippocratic Portal Username and Password
            </Text>
            <FieldsContainer>
              <TextField
                title={"Username/Email:"}
                direction={"column"}
                type={"text"}
                value={Username}
                setValue={setUsername}
              />
              <TextField
                title={"Password:"}
                direction={"column"}
                type={"password"}
                value={Password}
                setValue={setPassword}
              />
              <Error>{error}</Error>
            </FieldsContainer>
            {/* <ButtonContainer style={{ margin: " 0px" }}>
              <input type="checkbox" /> <CheckBoxText>Remember me</CheckBoxText>
            </ButtonContainer> */}
            <ButtonContainer>
              <CustomButton title="SIGN IN" handle={Submit} />
              <CustomButton
                title="Forgot password?"
                background={"var(--white)"}
                color={"var(--darkBlue)"}
                border={true}
                handle={() =>
                  navigation("/ValidateUsername")
                }
              />
            </ButtonContainer>
            </LeftContaienrContent>
          </LeftContaienr>
        </InnerContainer>
      </Container>
      <Footer />
    </>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 95vh;
`;

const InnerContainer = styled.div`
  padding: 100px 100px;
  min-height: 85vh;
  width: 90vw;
  border-radius: 30px;
  background-image: url(${womanDoctor});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: local;
  padding: 7%;
  
  @media screen and (max-width: 662px) {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
`;

const LeftContaienr = styled.div`
  display: flex;
  flex-direction: column;
  width: 30vw;
  min-width: 300px;
    border-radius: 20px;
  gap: 2vh;
  border-radius: 20px;
  background: #ecf3fb;
  

`;
const LeftContaienrBanner = styled.div`
display:flex;
width:auto;
background-color:#304961;
min-height:2vh;
padding:5%;
border-radius: 20px 20px 0 0;
align-items: center;
justify-content: center;
  box-shadow:0px 0px 10px #304961;


`;
const LeftContaienrContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
  width: auto;
  gap: 2vh;
  background: #ecf3fb;
  padding:2%;
  border-radius:20px;

  @media screen and (max-width: 662px) {
    gap: 20px;
    padding: 20px 10px;
  }
`;


const Title = styled.p`
  margin-bottom: 20px;
  color: var(--white);
font-family: 'Georgia';
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 90%;
  letter-spacing: 1px;
  white-space: wrap;
  text-transform: uppercase;


`;

const Text = styled.p`
  color: var(--darkBlue);

  font-family: "Museo Sans Cyrl";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 120% */

  padding: 0px 20px;
`;

const Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 129px;
  height: 40px;

  border-radius: 20px;

  cursor: pointer;
  background-color: var(--darkBlue);

  color: var(--white);
  text-align: center;
  font-family: "Museo Sans Cyrl";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
`;

const FieldsContainer = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 10px;
`;

const CheckBoxText = styled.div`
  color: var(--darkBlue);
  text-align: right;
  font-family: "Museo Sans Cyrl";
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
`;

const Error = styled.div`
  color: #b20000;
  text-align: left;
  width: 80%;
  font-family: "Museo Sans Cyrl";
  font-size: 12px;
  font-style: italic;
  font-weight: 300;
`;

export default RequireLogout(Login);
